import { OVERDUE_BG, OVERDUE_FG } from "../../Utils/designTokens";
import { getRemoteText } from "../../Utils/firebase";
import { FormatAmountSymbol } from "../FormatData/FormatAmount";

interface Props {
  /** summary `lateCreditCount` */
  count: number;
  /** summary `totalLateAmount` */
  amount: number;
}

/**
 * CRL-3241 `.summary__overdue`: red pill under the summary subtitle —
 * "⏱ N gecikmiş ödemen var · ₺X". Rendered only when something is late.
 */
const OverdueSummaryChip = ({ count, amount }: Props) => {
  if (!count || count <= 0) return null;

  return (
    <div
      className="inline-flex items-center gap-[6px] self-start mt-3 px-3 py-2 rounded-[14px] text-[13px] font-semibold"
      style={{ background: OVERDUE_BG, color: OVERDUE_FG }}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>
      <span>
        <b className="font-extrabold">
          {getRemoteText("overdue_payments_x", "{val} gecikmiş ödemen", String(count))}
        </b>{" "}
        {getRemoteText("overdue_payments_suffix", "var")} ·{" "}
        <b className="font-extrabold">{FormatAmountSymbol(amount)}</b>
      </span>
    </div>
  );
};

export default OverdueSummaryChip;
